import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './componentes/home/home.component';
import { CursoComponent } from './componentes/curso/curso.component';
import { AboutComponent } from './componentes/about/about.component';
import { AdminComponent } from './componentes/admin/admin.component';
import { LoginComponent } from './componentes/auth/login/login.component';
import { ContainerAppComponent } from "./componentes/container-app/container-app.component";
import { CursosDisponiblesComponent } from './componentes/cursos-disponibles/cursos-disponibles.component';
import { ProfileComponent } from './componentes/profile/profile.component';

import { AuthGuard } from "./guards/auth.guard";
import { DetailsCursoComponent } from './componentes/details-curso/details-curso.component';
import { RegistroComponent } from './componentes/auth/registro/registro.component';
import { Error404Component } from './componentes/error404/error404.component';
import { AdminGuard } from './guards/admin.guard';
import { ReproducirCursoComponent } from './componentes/reproducir-curso/reproducir-curso.component';
import { WoyaComponent } from './componentes/woya/woya.component';
import { AuditoriasComponent } from './componentes/auditorias/auditorias.component';
import { QuiensoyComponent } from './componentes/quiensoy/quiensoy.component';
import { DetailsNoticiaComponent } from './componentes/details-noticia/details-noticia.component';
import { HabilitarComponent } from './componentes/habilitar/habilitar.component';
import { NuevaImagenComponent } from './componentes/nueva-imagen/nueva-imagen.component';
import { NuevoDibujoComponent } from './componentes/nuevo-dibujo/nuevo-dibujo.component';
import { NuevoLibroComponent } from './componentes/nuevo-libro/nuevo-libro.component';

const routes: Routes = [{ path: '', component: ContainerAppComponent,
children:[
  {path:"entrada/:id", component:DetailsCursoComponent},// canActivate:[AuthGuard]},
  {path:"noticia/:id", component:DetailsNoticiaComponent},//, canActivate:[AuthGuard]},
  {path:"contacto", component:AboutComponent},
  {path:"quien", component:QuiensoyComponent},

  //{path:"home", component:HomeComponent},
  {path:"", component:HomeComponent},
  //{path:"", redirectTo:"home", pathMatch:"full"}, 

] 
},
{path:"admin", component:AdminComponent, canActivate:[AdminGuard,AuthGuard],
 children: [
  {path:"notas", component: CursosDisponiblesComponent},
  {path:"imagen", component: NuevaImagenComponent},
  {path:"dibujo", component: NuevoDibujoComponent},
  {path:"libro", component: NuevoLibroComponent},
  {path:"profile", component: ProfileComponent},
  {path:"auditorias", component: AuditoriasComponent},


  ]
},
// {path:"woya/:id/:secreto", component:WoyaComponent, canActivate:[AuthGuard]},
{path:"donar", component:HabilitarComponent},
{path:"login", component:LoginComponent},
{path: "registro", component:RegistroComponent},
{path: "**", component:Error404Component},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
